import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link
              to="/"
              className="flex items-center gap-2 text-foreground-900 mb-4"
            >
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-mental-health-line text-2xl text-primary-500"></i>
              </div>
              <span className="font-heading text-lg font-semibold whitespace-nowrap">
                膀胱健康知识网
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              专注泌尿健康科普，提供科学的膀胱保健知识和训练方法，帮助每一位关注健康的人拥有更好的生活品质。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">
              知识分类
            </h4>
            <ul className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">
              热门文章
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link
                  to="/article/bladder-basics-structure-function"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                >
                  膀胱基础知识：结构与功能
                </Link>
              </li>
              <li>
                <Link
                  to="/article/pelvic-floor-exercise-guide"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                >
                  盆底肌训练完全指南
                </Link>
              </li>
              <li>
                <Link
                  to="/article/timed-voiding-technique"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                >
                  定时排尿法：重建膀胱节律
                </Link>
              </li>
              <li>
                <Link
                  to="/article/bladder-irritant-foods"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                >
                  膀胱刺激性食物清单
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">
              关于我们
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/about#contact"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                >
                  联系我们
                </Link>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors duration-200"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors duration-200"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line text-base"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 膀胱健康知识网 版权所有 | 本站内容仅供健康科普参考，不构成医疗建议
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap" rel="nofollow">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}